import { CaregiverRoleEnum } from '@/shared/enums';
import { fetch } from '@/shared/fetch';

import { ICaregiverConsultationDto } from '@/caregiverSpace/shared/model';

export const fetchWaitingRoomTextConsultations = (
    role?: CaregiverRoleEnum | null,
): Promise<ICaregiverConsultationDto[]> => {
    const url =
        role != null
            ? `/api/caregiverspace/waiting-room/text?role=${role}`
            : '/api/caregiverspace/waiting-room/text';
    return fetch(url, 'GET');
};
